import { RecordersContainer } from "./GroupContainer";

export default RecordersContainer;
